





































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import { STORE_KEY, store, PACKAGE_STATUS } from './_store';
import {
  createOneCExportWorkbook,
  onecBatchFilename,
  onecShiftFilename,
} from './onecXlsx';

/** Нормализация id партии: «d:shift_atom_coock_plan:8380» / 8380 / «8380» → 8380. */
function pkOf(value: any): any {
  if (value == null) {
    return value;
  }
  const match = /(\d+)\s*$/.exec(String(value));
  return match ? Number(match[1]) : value;
}

@Component({
  props: {
    documentId: { type: [String, Number], required: true },
    closed: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(STORE_KEY, ['loading', 'loaded', 'fatalError', 'retrying', 'packages']),
    ...mapGetters(STORE_KEY, ['summary', 'inProgress']),
  },
})
export default class ShiftOneCExport extends Vue {
  private pollTimer: any = null;
  private downloadingRow: any = null;
  private downloadingAll = false;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
    this.reload();
    // статусы обновляются после получения ответа 1С — опрашиваем, пока обмен в процессе
    this.pollTimer = setInterval(() => {
      if ((this as any).inProgress) {
        this.reload();
      }
    }, 30000);
  }

  public beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  private reload() {
    // @ts-ignore
    this.$store.dispatch(`${STORE_KEY}/loadData`, { documentId: this.documentId });
  }

  private statusLabel(status: string): string {
    return PACKAGE_STATUS[status] ? PACKAGE_STATUS[status].label : status;
  }

  private statusType(status: string): string {
    return PACKAGE_STATUS[status] ? PACKAGE_STATUS[status].type : 'is-light';
  }

  private async onRetry() {
    try {
      // @ts-ignore
      await this.$store.dispatch(`${STORE_KEY}/retry`);
      this.$buefy.snackbar.open('Пакеты поставлены в очередь на отправку');
    } catch (e) {
      // @ts-ignore
      this.$buefy.snackbar.open({ type: 'is-danger', message: e.message });
    }
  }

  /** XLSX одной партии: пересчёт партии и выгрузка её данных. */
  private async onDownloadRow(row: any) {
    this.downloadingRow = row.id;
    try {
      const packages = await this.dispatchRecalculate(pkOf(row.coock_plan_id));
      const target = (packages || []).find(
        (p: any) => pkOf(p.coock_plan_id) === pkOf(row.coock_plan_id),
      );
      if (!target || !target.payload) {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `Партия ${row.batch_number}: нет рассчитанных данных (${row.error_code || 'расчёт не выполнен'})`,
        });
        return;
      }
      await this.saveWorkbook([target], onecBatchFilename(row.batch_number));
    } catch (e) {
      this.downloadError(e);
    } finally {
      this.downloadingRow = null;
    }
  }

  /** XLSX всех партий смены: пересчёт и выгрузка общей группировкой. */
  private async onDownloadAll() {
    this.downloadingAll = true;
    try {
      const packages = await this.dispatchRecalculate();
      const withPayload = (packages || []).filter((p: any) => p.payload);
      if (!withPayload.length) {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: 'Нет рассчитанных данных ни по одной партии',
        });
        return;
      }
      const shiftDate = this.payloadField(withPayload[0], (p: any) => p.shift && p.shift.date);
      await this.saveWorkbook(withPayload, onecShiftFilename(shiftDate, (this as any).documentId));
    } catch (e) {
      this.downloadError(e);
    } finally {
      this.downloadingAll = false;
    }
  }

  private dispatchRecalculate(batchId?: any): Promise<any[]> {
    // @ts-ignore
    return this.$store.dispatch(`${STORE_KEY}/recalculate`, batchId ? {batchId} : {});
  }

  private async saveWorkbook(packages: any[], filename: string) {
    const workbook = createOneCExportWorkbook(packages);
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }), filename);
  }

  private payloadField(pkg: any, selector: (payload: any) => any) {
    try {
      const payload = typeof pkg.payload === 'string' ? JSON.parse(pkg.payload) : pkg.payload;
      return selector(payload);
    } catch (e) {
      return undefined;
    }
  }

  private downloadError(e: any) {
    // @ts-ignore
    this.$buefy.snackbar.open({ type: 'is-danger', message: e && e.message ? e.message : 'Ошибка выгрузки' });
  }
}
